<script setup>
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
</script>

<template>
	<slot>
		<div class="mt-5">
			{{ translator.t("main", "No events") }}
		</div>
	</slot>
</template>
